import React, { useCallback } from 'react';
import { Wrapper, Box, Heading } from 'roo-ui/components';
import { useSelector } from 'react-redux';
import { useModal } from 'lib/hooks';
import { useDataLayer } from 'hooks/useDataLayer';
import { getRoomType } from 'store/booking/bookingSelectors';
import TextButton from 'components/TextButton';
import Markup from 'components/Markup';
import Modal from 'components/Modal';
import FacilitiesList from 'components/FacilitiesList';

const RoomTypeDetails = () => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();
  const roomType = useSelector(getRoomType);
  const { name: roomName, description: roomDescription, roomTypeFacilities: roomFacilities } = roomType;

  const openRoomDetailsModal = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'Room Details Pop Up', value: 'Link Selected' });
  }, [openModal, emitInteractionEvent]);

  return (
    <Wrapper>
      <TextButton onClick={openRoomDetailsModal} color="greys.charcoal" fontSize={['sm', 'base']} lineHeight="loose">
        {roomName}
      </TextButton>

      <Modal {...modalProps} title="Room details">
        <Box fontSize={['sm', 'base']} mb={4} data-testid="room-description">
          <Markup content={roomDescription} />
        </Box>
        <Heading.h4 mt={8}>Room facilities</Heading.h4>
        <FacilitiesList fontSize={['sm', 'base']} mb={4} facilities={roomFacilities} />
      </Modal>
    </Wrapper>
  );
};

export default RoomTypeDetails;
